
// import React, { useEffect, useState } from 'react';
// import NochatIcon from "../assets/images/no-chat.svg"
// import { Severty, ShowToast } from '../helper/toast';
// import useRequest from '../hooks/useRequest';
// function ChatWindow({ chat }) {
//   const [messages, setMessages] = useState([]);
//   const [text, setText] = useState('');
//   const { request } = useRequest()

//   // useEffect(() => {
//   //   if (chat) {
//   //     fetch(`https://backend.wehadbot.com/api/business/whatsup/messages/${chat.id}`)
//   //       .then(res => res.json())
//   //       .then(data => setMessages(data));
//   //   }
//   // }, [chat]);

//   useEffect(() => {
//     if (chat) {
//       request({
//         url: `https://backend.wehadbot.com/api/business/whatsup/messages/${chat.id}`,
//         method: "GET",
//         onSuccess: (data) => {
//           setMessages(data);
//         },
//         onError: (error) => {
//           ShowToast(error?.response?.data?.message || "Failed to load messages", Severty.ERROR);
//         },
//       });
//     }
//   }, [chat]);


//   const sendMessage = async () => {
//     request({
//       url: "https://backend.wehadbot.com/api/business/whatsup/send-message",
//       method: "POST",
//       data: { to: chat.id, message: text },
//       onSuccess: () => {
//         setText('');
//       },
//       onError: (error) => {
//         ShowToast(error?.response?.data?.message || "Message sending failed", Severty.ERROR);
//       },
//     });
//   };


//   // const sendMessage = async () => {
//   //   await fetch('https://backend.wehadbot.com/api/business/whatsup/send-message', {
//   //     method: 'POST',
//   //     headers: { 'Content-Type': 'application/json' },
//   //     body: JSON.stringify({ to: chat.id, message: text }),
//   //   });
//   //   setText('');
//   // };

//   if (!chat) return <div className="chat-window">
//     <div className='no-data-chat'>
//       <img src={NochatIcon} />
//     </div>
//   </div>;

//   return (
//     <div className="chat-window">
//       <div className='chat-header-chatbody'>
//         <h3>{chat.name || chat.id}</h3>
//       </div>
//       <div className="message-list">
//         {messages.map((msg, idx) => (
//           msg.type === 'chat' ?
//             <div key={idx} className={`message ${msg.from === chat.id ? 'incoming' : 'outgoing'}`}>
//               {msg.body}


//             </div> : ""
//         ))}
//       </div>

//       <div className="message-input">
//         <input
//           type="text"
//           value={text}
//           onChange={e => setText(e.target.value)}
//           placeholder="Type a message"
//         />
//         <button onClick={sendMessage}>Send</button>
//       </div>
//     </div>

//   );
// }


// export default ChatWindow;
// import React, { useEffect, useState } from 'react';
// import NochatIcon from "../assets/images/no-chat.svg";
// import { Severty, ShowToast } from '../helper/toast';
// import useRequest from '../hooks/useRequest';

// function ChatWindow({ chat }) {
//   const [messages, setMessages] = useState([]);
//   const [text, setText] = useState('');
//   const [mediaFile, setMediaFile] = useState(null);
//   const [recorder, setRecorder] = useState(null);
//   const [audioBlob, setAudioBlob] = useState(null);
//   const [isRecording, setIsRecording] = useState(false);
//   const { request } = useRequest();

//   useEffect(() => {
//     if (chat) {
//       request({
//         url: `https://backend.wehadbot.com/api/business/whatsup/messages/${chat.id}`,
//         method: "GET",
//         onSuccess: (data) => setMessages(data),
//         onError: (error) => {
//           ShowToast(error?.response?.data?.message || "Failed to load messages", Severty.ERROR);
//         },
//       });
//     }
//   }, [chat]);

//   // Initialize voice recorder
//   useEffect(() => {
//     if (!recorder && navigator.mediaDevices) {
//       navigator.mediaDevices.getUserMedia({ audio: true }).then((stream) => {
//         const mediaRecorder = new MediaRecorder(stream);
//         setRecorder(mediaRecorder);
//       });
//     }
//   }, []);

//   const sendTextMessage = () => {
//     if (!text.trim()) return;
//     request({
//       url: "https://backend.wehadbot.com/api/business/whatsup/send-message",
//       method: "POST",
//       data: { to: chat.id, message: text },
//       onSuccess: () => setText(''),
//       onError: (error) => {
//         ShowToast(error?.response?.data?.message || "Message sending failed", Severty.ERROR);
//       },
//     });
//   };

//   const handleFileUpload = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     const reader = new FileReader();
//     reader.onloadend = () => {
//       const base64 = reader.result.split(',')[1];
//       request({
//         url: "https://backend.wehadbot.com/api/business/whatsup/send-media",
//         method: "POST",
//         data: {
//           to: chat.id,
//           media: base64,
//           type: file.type,
//           filename: file.name
//         },
//         onSuccess: () => ShowToast("Media sent", Severty.SUCCESS),
//         onError: (err) => ShowToast("Failed to send media", Severty.ERROR)
//       });
//     };
//     reader.readAsDataURL(file);
//   };

//   const startRecording = () => {
//     if (recorder) {
//       setIsRecording(true);
//       recorder.start();
//       recorder.ondataavailable = (e) => setAudioBlob(e.data);
//     }
//   };

//   const stopRecording = () => {
//     if (recorder) {
//       setIsRecording(false);
//       recorder.stop();
//     }
//   };

//   const sendVoiceMessage = () => {
//     if (!audioBlob) return;
//     const reader = new FileReader();
//     reader.onloadend = () => {
//       const base64 = reader.result.split(',')[1];
//       request({
//         url: "https://backend.wehadbot.com/api/business/whatsup/send-media",
//         method: "POST",
//         data: {
//           to: chat.id,
//           media: base64,
//           type: "audio/ogg",
//           filename: "voice.ogg"
//         },
//         onSuccess: () => {
//           setAudioBlob(null);
//           ShowToast("Voice message sent", Severty.SUCCESS);
//         },
//         onError: () => ShowToast("Voice sending failed", Severty.ERROR)
//       });
//     };
//     reader.readAsDataURL(audioBlob);
//   };

//   if (!chat) {
//     return (
//       <div className="chat-window">
//         <div className="no-data-chat">
//           <img src={NochatIcon} alt="No Chat" />
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="chat-window">
//       <div className="chat-header-chatbody">
//         <h3>{chat.name || chat.id}</h3>
//       </div>

//       <div className="message-list">
//         {messages.map((msg, idx) =>
//           msg.type === 'chat' ? (
//             <div key={idx} className={`message ${msg.from === chat.id ? 'incoming' : 'outgoing'}`}>
//               {msg.body}
//             </div>
//           ) : null
//         )}
//       </div>

//       <div className="message-input">
//         <input
//           type="text"
//           value={text}
//           onChange={(e) => setText(e.target.value)}
//           placeholder="Type a message"
//         />
//         <button onClick={sendTextMessage}>Send</button>

//         <input
//           type="file"
//           accept="image/*,video/*"
//           onChange={handleFileUpload}
//           style={{ marginLeft: "10px" }}
//         />

//         <button onClick={startRecording} disabled={isRecording}>
//           🎤 Start
//         </button>
//         <button onClick={stopRecording} disabled={!isRecording}>
//           🛑 Stop
//         </button>
//         <button onClick={sendVoiceMessage} disabled={!audioBlob}>
//           📤 Send Voice
//         </button>
//       </div>
//     </div>
//   );
// }

// export default ChatWindow;



// import React, { useEffect, useRef, useState } from "react";
// import NochatIcon from "../assets/images/no-chat.svg";
// import { Severty, ShowToast } from "../helper/toast";
// import WhatsAppIcon from "../assets/images/whatsapp-icon.svg";
// import PinImage from "../assets/images/paperclip.png";
// import SendImage from "../assets/images/message-send-icon.png";
// import StopreImage from "../assets/images/mute.png";
// import StartreImage from "../assets/images/mic.png";
// import FileImage from "../assets/images/file.png";
// import VoicereImage from "../assets/images/voice.png";
// import useRequest from "../hooks/useRequest";
// import { Button } from "antd";

// function ChatWindow({ chat, scanId }) {
//   const [messages, setMessages] = useState([]);
//   const [text, setText] = useState("");
//   const [selectedFile, setSelectedFile] = useState(null);
//   const [audioBlob, setAudioBlob] = useState(null);
//   const [recorder, setRecorder] = useState(null);
//   const [isRecording, setIsRecording] = useState(false);
//   const { request } = useRequest();
//   const messageEndRef = useRef(null);
//   const [refresh, setRefresh] = useState(false);

//   useEffect(() => {
//     if (chat) {
//       request({
//         url: `https://backend.wehadbot.com/api/business/whatsup/messages/${chat.id}/${scanId}`,
//         method: "GET",
//         onSuccess: (data) => setMessages(data),
//         onError: (error) => {
//           console.log("error", error)
//           ShowToast(
//             error?.response?.data?.message || "Failed to load messages",
//             Severty.ERROR
//           );
//         },
//       });
//     }
//   }, [chat, refresh]);

//   useEffect(() => {
//     messageEndRef.current?.scrollIntoView({ behavior: "smooth" });
//   }, [messages]);

//   useEffect(() => {
//     if (navigator.mediaDevices && MediaRecorder) {
//       navigator.mediaDevices.getUserMedia({ audio: true })
//         .then((stream) => {
//           const mediaRecorder = new MediaRecorder(stream, {
//             mimeType: "audio/webm; codecs=opus",
//           });

//           let chunks = [];
//           mediaRecorder.ondataavailable = (e) => {
//             chunks.push(e.data);
//           };

//           mediaRecorder.onstop = () => {
//             const blob = new Blob(chunks, { type: "audio/webm; codecs=opus" });
//             setAudioBlob(blob);
//             chunks = [];
//           };

//           setRecorder(mediaRecorder);
//           console.log("MediaRecorder initialized successfully");
//         })
//         .catch((error) => {
//           console.error("Error accessing media devices.", error);
//           ShowToast("Could not access microphone", Severty.ERROR);
//         });
//     } else {
//       console.error("MediaRecorder is not supported in this browser.");
//       ShowToast("MediaRecorder is not supported in this browser", Severty.ERROR);
//     }
//   }, []);


//   const sendTextMessage = () => {
//     if (!text.trim()) return;

//     request({
//       url: `https://backend.wehadbot.com/api/business/whatsup/send-message/${scanId}`,
//       method: "POST",
//       data: { to: chat.id, message: text },
//       onSuccess: () => { setText(""); setRefresh((prev) => !prev); },
//       onError: () =>
//         ShowToast("Message sending failed", Severty.ERROR),
//     });
//   };

//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     if (file) setSelectedFile(file);
//   };

//   const sendSelectedMedia = () => {
//     if (!selectedFile) return;

//     const reader = new FileReader();
//     reader.onloadend = () => {
//       const base64 = reader.result.split(",")[1];
//       request({
//         // url: `https://backend.wehadbot.com/api/business/whatsup/send-media/${scanId}`,
//         url: `https://backend.wehadbot.com/api/business/whatsup/send-media/${scanId}`,
//         method: "POST",
//         data: {
//           to: chat.id,
//           media: base64,
//           type: selectedFile.type,
//           filename: selectedFile.name,
//         },
//         onSuccess: () => {
//           ShowToast("Media sent", Severty.SUCCESS);
//           setSelectedFile(null);
//         },
//         onError: () =>
//           ShowToast("Failed to send media", Severty.ERROR),
//       });
//     };

//     reader.readAsDataURL(selectedFile);
//   };

//   const startRecording = () => {
//     console.log("Attempting to start recording...");
//     if (recorder && !isRecording) {
//       setIsRecording(true);
//       recorder.start();
//       console.log("Recording started");
//     } else {
//       console.warn("Recorder is not available or already recording");
//     }
//   };


//   const stopRecording = () => {
//     if (recorder && isRecording) {
//       recorder.stop();
//       setIsRecording(false);
//     }
//   };

//   useEffect(() => {
//     if (navigator.mediaDevices) {
//       const mimeTypes = [
//         "audio/webm; codecs=opus", // More widely supported
//         "audio/webm",               // Another fallback
//         "audio/ogg; codecs=opus",   // Original type
//       ];

//       const supportedMimeType = mimeTypes.find((type) => MediaRecorder.isTypeSupported(type));

//       if (supportedMimeType) {
//         navigator.mediaDevices.getUserMedia({ audio: true }).then((stream) => {
//           const mediaRecorder = new MediaRecorder(stream, { mimeType: supportedMimeType });
//           let chunks = [];
//           mediaRecorder.ondataavailable = (e) => {
//             chunks.push(e.data);
//           };

//           mediaRecorder.onstop = () => {
//             const blob = new Blob(chunks, { type: supportedMimeType });
//             setAudioBlob(blob);
//             chunks = [];
//           };

//           setRecorder(mediaRecorder);
//         });
//       } else {
//         console.error("No supported mime type for MediaRecorder found");
//       }
//     }
//   }, []);


//   const sendVoiceMessage = () => {
//     if (!audioBlob) return;

//     const reader = new FileReader();
//     reader.onloadend = () => {
//       const base64 = reader.result.split(",")[1];
//       request({
//         // url: `https://backend.wehadbot.com/api/business/whatsup/send-media/${scanId}`,
//         url: `https://backend.wehadbot.com/api/business/whatsup/send-media/${scanId}`,
//         method: "POST",
//         data: {
//           to: chat.id,
//           media: base64,
//           type: "audio/ogg; codecs=opus",
//           filename: "voice.opus",
//         },
//         onSuccess: () => {
//           setAudioBlob(null);
//           ShowToast("Voice message sent", Severty.SUCCESS);
//         },
//         onError: () =>
//           ShowToast("Voice sending failed", Severty.ERROR),
//       });
//     };
//     reader.readAsDataURL(audioBlob);
//   };


//   //   const sendVoiceMessage = () => {
//   //   if (!audioBlob) return;

//   //   const formData = new FormData();
//   //   formData.append("to", chat.id);
//   //   formData.append("type", "audio/ogg; codecs=opus");
//   //   formData.append("filename", "voice.ogg");
//   //   formData.append("media", new File([audioBlob], "voice.ogg", { type: "audio/ogg; codecs=opus" }));

//   //   request({
//   //     url: `https://backend.wehadbot.com/api/business/whatsup/send-media/${scanId}`,
//   //     method: "POST",
//   //     data: formData,
//   //     headers: {
//   //       "Content-Type": "multipart/form-data",
//   //     },
//   //     onSuccess: () => {
//   //       setAudioBlob(null);
//   //       ShowToast("Voice message sent", Severty.SUCCESS);
//   //     },
//   //     onError: () => {
//   //       ShowToast("Voice sending failed", Severty.ERROR);
//   //     },
//   //   });
//   // };

//   if (!chat) {
//     return (
//       <div className="chat-window">
//         <div className="no-data-chat">
//           <img src={NochatIcon} alt="No Chat" />
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="chat-window">
//       <div className="chat-header-chatbody">
//         <img width={40} src={WhatsAppIcon} alt="icon" />
//         <h3>{chat.name || chat.id}</h3>
//       </div>

//       <div className="message-list">
//         {messages.map((msg, idx) =>
//           msg.type === "chat" ? (
//             <div key={idx} className={`message ${msg.from === chat.id ? "incoming" : "outgoing"}`}>
//               {msg.body}
//             </div>
//           ) : null
//         )}
//         <div ref={messageEndRef} />
//       </div>

//       <div className="message-input">
//         <div className="message-input-index-jss">
//           <input
//             type="text"
//             value={selectedFile ? selectedFile.name : text}
//             onChange={(e) => setText(e.target.value)}
//             placeholder="Type a message"
//           />
//           <label className="upload-icon">
//             <img src={PinImage} />
//             <input
//               type="file"
//               accept="image/*,video/*"
//               onChange={handleFileChange}
//               hidden
//             />
//           </label>
//         </div>
//         <Button className="send-messag-button" onClick={() => { selectedFile ? sendSelectedMedia() : sendTextMessage() }}><img src={SendImage} /></Button>



//         <button onClick={sendSelectedMedia} disabled={!selectedFile}>    <img src={FileImage} /></button>

//         <button onClick={startRecording} disabled={isRecording}>
//           <img src={StartreImage} />
//         </button>
//         <button onClick={stopRecording} disabled={!isRecording}>
//           <img src={StopreImage} />
//         </button>
//         <button onClick={sendVoiceMessage} disabled={!audioBlob}>
//           <img src={VoicereImage} />
//         </button>
//       </div>
//     </div>
//   );
// }

// export default ChatWindow;



import React, { useEffect, useRef, useState } from "react";
import NochatIcon from "../assets/images/no-chat.svg";
import { Severty, ShowToast } from "../helper/toast";
import WhatsAppIcon from "../assets/images/whatsapp-icon.svg";
import PinImage from "../assets/images/paperclip.png";
import SendImage from "../assets/images/message-send-icon.png";
import StopreImage from "../assets/images/mute.png";
import StartreImage from "../assets/images/mic.png";
import FileImage from "../assets/images/file.png";
import VoicereImage from "../assets/images/voice.png";
import useRequest from "../hooks/useRequest";
import { Button } from "antd";
import { uploadFileToS3 } from "../helper/s3Uploader";
import EmojiPicker from "emoji-picker-react";

function ChatWindow({ chat, scanId }) {
  const [messages, setMessages] = useState([]);
  const [text, setText] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [audioBlob, setAudioBlob] = useState(null);
  const [recorder, setRecorder] = useState(null);
  const [isRecording, setIsRecording] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const { request } = useRequest();
  const messageEndRef = useRef(null);
  const [refresh, setRefresh] = useState(false);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);


  // Format date like WhatsApp Web
  const formatMessageDate = (timestamp) => {
    const messageDate = new Date(timestamp * 1000); // Convert Unix timestamp to milliseconds
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    // Reset time to compare only dates
    const messageDateOnly = new Date(messageDate.getFullYear(), messageDate.getMonth(), messageDate.getDate());
    const todayOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    const yesterdayOnly = new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate());

    if (messageDateOnly.getTime() === todayOnly.getTime()) {
      return "Today";
    } else if (messageDateOnly.getTime() === yesterdayOnly.getTime()) {
      return "Yesterday";
    } else {
      // Format as "DD/MM/YYYY" or use locale string
      return messageDate.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    }
  };

  // Format time for message
  const formatMessageTime = (timestamp) => {
    const messageDate = new Date(timestamp * 1000);
    return messageDate.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  };

  // Group messages by date
  const groupMessagesByDate = (messages) => {
    const grouped = {};

    messages.forEach(message => {
      const dateKey = formatMessageDate(message.timestamp);
      if (!grouped[dateKey]) {
        grouped[dateKey] = [];
      }
      grouped[dateKey].push(message);
    });

    return grouped;
  };

  // Fetch messages
  useEffect(() => {

    let isMounted = true;
    let timeoutId;

    const fetchMessages = () => {
      if (!chat) return;
      request({
        // url: `https://backend.wehadbot.com/api/business/whatsup/messages/${chat.id}/${scanId}`,
        //url: `http://localhost:2064/api/business/whatsup/messages/${chat.id}/${scanId}`,
        url: `https://whtb.coffeeandaslice.com/api/business/whatsup/messages/${chat.id}/${scanId}`,

        method: "GET",
        onSuccess: (data) => {
          if (isMounted) {
            console.log('Received messages:', data);
            // Log any image messages
            const imageMessages = data.filter(msg => msg.type === 'image');
            if (imageMessages.length > 0) {
              console.log('Found image messages:', imageMessages);
            }
            setMessages(data);
          }
          // Schedule next poll only after this one finishes
          if (isMounted) {
            timeoutId = setTimeout(fetchMessages, 5000);
          }
        },
        onError: (error) => {
          console.error('Error fetching messages:', error);
          // error handling
          if (isMounted) {
            timeoutId = setTimeout(fetchMessages, 5000);
          }
        },
      });
    };

    fetchMessages();

    return () => {
      isMounted = false;
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [chat, scanId]);

  // Auto-scroll to bottom
  useEffect(() => {
    messageEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  // Initialize media recorder
  useEffect(() => {
    if (!navigator.mediaDevices || !MediaRecorder) {
      console.error("MediaRecorder not supported");
      ShowToast("MediaRecorder is not supported in this browser", Severty.ERROR);
      return;
    }

    const initRecorder = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

        // Try different mime types in order of preference
        const mimeType = [
          'audio/mp3',
          'audio/mpeg',
          'audio/webm',
          'audio/ogg; codecs=opus'
        ].find(type => MediaRecorder.isTypeSupported(type)) || 'audio/webm';

        console.log("Using mimeType:", mimeType);

        const recorder = new MediaRecorder(stream, { mimeType });
        let chunks = [];

        recorder.ondataavailable = (e) => {
          chunks.push(e.data);
        };

        recorder.onstop = () => {
          const blob = new Blob(chunks, { type: mimeType });
          setAudioBlob(blob);
          chunks = [];
        };

        setRecorder(recorder);
      } catch (error) {
        console.error("Error initializing recorder:", error);
        ShowToast("Could not access microphone", Severty.ERROR);
      }
    };

    initRecorder();

    return () => {
      // Cleanup
      if (recorder && recorder.stream) {
        recorder.stream.getTracks().forEach(track => track.stop());
      }
    };
  }, []);

  // Send text message
  const sendTextMessage = () => {
    if (!text.trim()) return;
    setShowEmojiPicker(false)
    request({
      // url: `https://backend.wehadbot.com/api/business/whatsup/send-message/${scanId}`,
      //url: `https://backend.wehadbot.com/api/business/whatsup/send-message/${scanId}`,
      url: `https://whtb.coffeeandaslice.com/api/business/whatsup/send-message/${scanId}`,
      method: "POST",
      data: { to: chat.id, message: text },
      onSuccess: () => {
        setText("");
        setRefresh((prev) => !prev);
      },
      onError: () => {
        ShowToast("Message sending failed", Severty.ERROR);
      },
    });
  };

  // Handle file selection
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      setText(file.name); // Show file name in input
    }
  };

  // Send media file
  const sendSelectedMedia = async () => {
    if (!selectedFile) return;

    setIsSending(true);
    try {
      const s3Url = await uploadFileToS3(selectedFile);
      const formData = new FormData();
      formData.append('to', chat.id);
      formData.append('type', selectedFile.type);
      formData.append('filename', selectedFile.name);
      formData.append('media', selectedFile);
      formData.append('mediaUrl', s3Url);


      await request({
        // url: `https://backend.wehadbot.com/api/business/whatsup/send-media/${scanId}`,
        url: `https://backend.wehadbot.com/api/business/whatsup/send-media/${scanId}`,
        method: "POST",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      ShowToast("Media sent", Severty.SUCCESS);
      setSelectedFile(null);
      setText("");
      setRefresh(prev => !prev);
    } catch (error) {
      console.error("Error sending media:", error);
      ShowToast("Failed to send media", Severty.ERROR);
    } finally {
      setIsSending(false);
    }
  };

  // Start recording
  const startRecording = () => {
    if (recorder && !isRecording) {
      setIsRecording(true);
      recorder.start();
      ShowToast("Recording started", Severty.INFO);
    }
  };

  // Stop recording
  const stopRecording = () => {
    if (recorder && isRecording) {
      recorder.stop();
      setIsRecording(false);
      ShowToast("Recording stopped", Severty.INFO);
    }
  };

  // Send voice message
  const sendVoiceMessage = async () => {
    console.log(audioBlob, "audioBlob")
    if (!audioBlob) return;

    setIsSending(true);
    try {
      const audioFile = new File([audioBlob], `voice_${Date.now()}.webm`, { type: "audio/webm" });
      const s3Url = await uploadFileToS3(audioFile);
      const formData = new FormData();
      formData.append('to', chat.id);
      formData.append('type', 'audio/mp3'); // Using MP3 as default
      formData.append('filename', 'voice.mp3');
      formData.append('media', new File([audioBlob], 'voice.mp3', { type: 'audio/mp3' }));
      formData.append('mediaUrl', s3Url);
      await request({
        // url: `https://backend.wehadbot.com/api/business/whatsup/send-media/${scanId}`,
        url: `https://backend.wehadbot.com/api/business/whatsup/send-media/${scanId}`,
        method: "POST",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      ShowToast("Voice message sent", Severty.SUCCESS);
      setAudioBlob(null);
      setRefresh(prev => !prev);
    } catch (error) {
      console.error("Error sending voice message:", error);
      ShowToast("Voice sending failed", Severty.ERROR);
    } finally {
      setIsSending(false);
    }
  };

  // Play recorded audio (for testing)
  const playRecordedAudio = () => {
    if (audioBlob) {
      const audioURL = URL.createObjectURL(audioBlob);
      const audio = new Audio(audioURL);
      audio.play();
    }
  };

  // Function to try different WhatsApp image loading approaches
  const loadWhatsAppImage = (mediaUrl, imgElement) => {
    console.log('Starting WhatsApp image loading for:', mediaUrl);

    if (!mediaUrl) {
      console.error('No mediaUrl provided for image loading');
      return;
    }

    if (!imgElement) {
      console.error('No imgElement provided for image loading');
      return;
    }

    const approaches = [
      mediaUrl, // Original URL
      mediaUrl + '&_nc_ht=mmg.whatsapp.net', // With host parameter
      mediaUrl + '&_nc_cat=1', // With category parameter
      mediaUrl + '&_nc_sid=5e03e0', // With session ID
      mediaUrl + '?t=' + Date.now(), // With timestamp
    ];

    let currentIndex = 0;

    const tryNextApproach = () => {
      if (currentIndex >= approaches.length) {
        console.log('All image loading approaches failed for:', mediaUrl);
        // Show error state
        const loadingDiv = imgElement.parentNode.querySelector('.image-loading');
        const errorDiv = imgElement.parentNode.querySelector('.image-error');
        if (loadingDiv) loadingDiv.style.display = 'none';
        if (errorDiv) errorDiv.style.display = 'flex';
        return;
      }

      const url = approaches[currentIndex];
      console.log(`Trying image URL approach ${currentIndex + 1}:`, url);

      imgElement.src = url;
      currentIndex++;
    };

    imgElement.onerror = () => {
      console.log(`Approach ${currentIndex} failed for URL:`, approaches[currentIndex - 1]);
      setTimeout(tryNextApproach, 100);
    };

    imgElement.onload = () => {
      console.log('Image loaded successfully with approach:', currentIndex, 'URL:', approaches[currentIndex - 1]);
      imgElement.style.display = 'block';
      const loadingDiv = imgElement.parentNode.querySelector('.image-loading');
      if (loadingDiv) {
        loadingDiv.style.display = 'none';
      }
    };

    // Start with first approach
    tryNextApproach();
  };

  // Render message content based on type
  const renderMessageContent = (message) => {
    console.log('Rendering message:', message);

    // Check if this is an image message
    if (message.type === 'image' && message.mediaUrl) {
      console.log('Processing image message with mediaUrl:', message.mediaUrl);
      return (
        <div className="message-media">
          <div style={{ position: 'relative' }}>
            {/* Loading indicator - shown by default */}
            <div className="image-loading" style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '250px',
              height: '150px',
              background: '#f0f0f0',
              borderRadius: '8px',
              color: '#666',
              fontSize: '12px',
              position: 'absolute',
              top: 0,
              left: 0,
              zIndex: 1
            }}>
              📷 Loading image...
            </div>

            {/* Image - hidden initially, shown when loaded */}
            <img
              ref={(img) => {
                if (img && message.mediaUrl) {
                  console.log('Setting up image with mediaUrl:', message.mediaUrl);
                  // Try direct loading first, then fallback to WhatsApp loading function
                  img.src = message.mediaUrl;
                  img.onerror = () => {
                    console.log('Direct loading failed, trying WhatsApp loading function');
                    loadWhatsAppImage(message.mediaUrl, img);
                  };
                }
              }}
              alt="Image"
              style={{
                maxWidth: '250px',
                maxHeight: '250px',
                borderRadius: '8px',
                cursor: 'pointer',
                objectFit: 'cover',
                display: 'none',
                position: 'relative',
                zIndex: 2
              }}
              onError={(e) => {
                console.log('Image error for:', message.mediaUrl);
                e.target.style.display = 'none';
                // Show error message
                const errorDiv = e.target.parentNode.querySelector('.image-error');
                if (errorDiv) {
                  errorDiv.style.display = 'flex';
                }
                // Hide loading indicator
                const loadingDiv = e.target.parentNode.querySelector('.image-loading');
                if (loadingDiv) {
                  loadingDiv.style.display = 'none';
                }
              }}
              onLoad={(e) => {
                console.log('Image loaded successfully:', message.mediaUrl);
                e.target.style.display = 'block';
                const loadingDiv = e.target.parentNode.querySelector('.image-loading');
                if (loadingDiv) {
                  loadingDiv.style.display = 'none';
                }
              }}
              onClick={() => {
                // Open image in new tab for full view
                window.open(message.mediaUrl, '_blank');
              }}
            />

            {/* Error message */}
            <div className="image-error" style={{
              display: 'none',
              alignItems: 'center',
              justifyContent: 'center',
              width: '250px',
              height: '150px',
              background: '#f0f0f0',
              borderRadius: '8px',
              color: '#666',
              fontSize: '12px',
              flexDirection: 'column',
              gap: '4px',
              position: 'absolute',
              top: 0,
              left: 0,
              zIndex: 3,
              cursor: 'pointer'
            }}
              onClick={() => {
                console.log('Retrying image load for:', message.mediaUrl);
                // Retry loading the image with all approaches
                const img = document.querySelector(`img[src*="${message.mediaUrl.split('?')[0]}"]`);
                if (img) {
                  img.style.display = 'none';
                  const loadingDiv = img.parentNode.querySelector('.image-loading');
                  const errorDiv = img.parentNode.querySelector('.image-error');
                  if (loadingDiv) loadingDiv.style.display = 'flex';
                  if (errorDiv) errorDiv.style.display = 'none';
                  // Restart the WhatsApp image loading process
                  loadWhatsAppImage(message.mediaUrl, img);
                }
              }}>
              🖼️ Image not available
              <div style={{ fontSize: '10px', opacity: 0.7 }}>
                Click to retry
              </div>
            </div>
          </div>
          {message.body && (
            <div className="message-text" style={{ marginTop: '8px' }}>
              {message.body}
            </div>
          )}
        </div>
      );
    }

    switch (message.type) {
      case 'video':
        return (
          <div className="message-media">
            <video
              controls
              style={{ maxWidth: '200px', maxHeight: '200px', borderRadius: '8px' }}
            >
              <source src={message.mediaUrl} type={message.mimetype} />
              Your browser does not support the video tag.
            </video>
          </div>
        );
      case 'audio':
        return (
          <div className="message-media">
            <audio controls style={{ maxWidth: '200px' }}>
              <source src={message.mediaUrl} type={message.mimetype} />
              Your browser does not support the audio tag.
            </audio>
          </div>
        );
      case 'ptt':
        return (
          <div className="message-media voice-message">
            <audio controls style={{ width: '180px', borderRadius: '20px', background: '#f0f0f0' }}>
              <source src={message.mediaUrl} type={message.mimetype || 'audio/ogg'} />
              Your browser does not support the audio tag.
            </audio>
          </div>
        );
      case 'document':
        return (
          <div className="message-media">
            <a href={message.mediaUrl} target="_blank" rel="noopener noreferrer">
              📎 {message.filename || 'Document'}
            </a>
          </div>
        );

      default:
        return <div className="message-text">{message.body}</div>;
    }
  };

  if (!chat) {
    return (
      <div className="chat-window">
        <div className="no-data-chat">
          <img src={NochatIcon} alt="No Chat" />
        </div>
      </div>
    );
  }


  const groupedMessages = groupMessagesByDate(messages);
  const onEmojiClick = (emojiData) => {
    setText((prev) => prev + emojiData.emoji)
  };

  return (
    <div className="chat-window">

      <div className="chat-header-chatbody">
        <img width={40} src={WhatsAppIcon} alt="icon" />
        <h3>{chat.name || chat.id}</h3>
      </div>
      {showEmojiPicker && (
        <div className="emoji-picker">
          <EmojiPicker onEmojiClick={onEmojiClick} />
        </div>
      )}
      <div className="message-list">

        {Object.entries(groupedMessages).map(([date, dateMessages]) => (
          <div key={date}>
            {/* Date separator */}
            <div className="date-separator">
              <span className="date-text">{date}</span>
            </div>

            {/* Messages for this date */}
            {dateMessages.map((msg, idx) => (
              <div key={`${date}-${idx}`} className={`message ${msg.from === chat.id ? "incoming" : "outgoing"}`}>
                {renderMessageContent(msg)}
                <div className="message-time">
                  {formatMessageTime(msg.timestamp)}
                </div>
              </div>
            ))}
          </div>
        ))}
        <div ref={messageEndRef} />
      </div>

      <div className="message-input">
        <div className="message-input-index-jss">
          <input
            type="text"
            value={text}
            onChange={(e) => setText(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && sendTextMessage()}
            placeholder="Type a message"
            disabled={isRecording || isSending}
          />
          <label className="upload-icon">
            <img src={PinImage} alt="Attach file" />
            <input
              type="file"
              accept="image/*,video/*,audio/*"
              onChange={handleFileChange}
              hidden
              disabled={isRecording || isSending}
            />

          </label>
          <button className="emoji-button"
            onClick={() => setShowEmojiPicker(!showEmojiPicker)}

          >
            😀
          </button>
        </div>



        {audioBlob && (
          <button onClick={playRecordedAudio} title="Play recording">
            <img src={VoicereImage} alt="Play recording" />
          </button>
        )}

        <Button
          className="send-messag-button"
          onClick={() => selectedFile ? sendSelectedMedia() : sendTextMessage()}
          disabled={isRecording || isSending}
        >
          <img src={SendImage} alt="Send" />
        </Button>

        {!isRecording ? (
          <button onClick={startRecording} disabled={isSending} title="Start recording">
            <img src={StartreImage} alt="Start recording" />
          </button>
        ) : (
          <button onClick={stopRecording} title="Stop recording">
            <img src={StopreImage} alt="Stop recording" />
          </button>
        )}

        {audioBlob && (
          <button onClick={sendVoiceMessage} disabled={isSending} title="Send voice message">
            <img src={FileImage} alt="Send voice" />
          </button>
        )}
      </div>
    </div>
  );
}

export default ChatWindow;